module.exports = __webpack_public_path__ + "img/47.7901be39.png";